import { Card, Tooltip } from 'antd'

import TableHasPagenation from '../../../components/TableHasPagenation'
import PurchaseItemOperateBtns from './PurchaseItemOperateBtns'
import useProcurementTypeContext from '../hooks/useProcurementTypeContext'
export default function BasicProcurementListTable({
  pageData = {},
  loading = false,
  selectedRowKeys = [],
  setSelectedRows = () => {},
  getList = () => {},
  modal = null,
  operateDetailText = '采购详情'
}) {
  const { isOrder } = useProcurementTypeContext()
  const columns = [
    {
      title: '序号',
      width: 60,
      render: (text, record, index) =>
        (pageData.pageIndex - 1) * pageData.pageSize + index + 1
    },
    {
      title: '采购单号',
      dataIndex: 'purchaseOrderNo'
    },
    {
      title: '采购单类型',
      dataIndex: 'purchaseTypeName'
      // render: text => purchaseTypeMap[text]
    },
    {
      title: '采购单状态',
      dataIndex: 'purchaseStatusName'
      // render: text => purchaseTypeMap[text]
    },
    {
      title: '所属供应商',
      dataIndex: 'supplierName'
    },
    {
      title: '数量',
      width: 68,
      dataIndex: 'totalQuantity'
    },
    {
      title: '总金额',
      width: 80,
      dataIndex: 'totalAmount'
    },
    {
      title: isOrder ? '是否付款' : '是否退款',
      dataIndex: 'fundStatusName'
      // render: text => (fundStatusMap[text] || {}).key
    },
    {
      title: '经手人',
      dataIndex: 'operator'
    },
    {
      title: '创建时间',
      dataIndex: 'createTime'
    },
    {
      title: '备注',
      dataIndex: 'remark',
      ellipsis: true
    },
    {
      title: '操作',
      dataIndex: 'action',
      //   align: 'center',
      render: (text, record, index) => (
        <PurchaseItemOperateBtns
          modal={modal}
          record={record}
          freshList={getList}
        />
      )
    }
  ]
  return (
    <Card>
      <TableHasPagenation
        loading={loading}
        rowSelection={{
          selectedRowKeys: selectedRowKeys,
          onChange: (selectedRowKeys, rows) => {
            setSelectedRows(rows)
          }
        }}
        rowKey='purchaseOrderNo'
        pageData={pageData}
        onPageSizeChange={getList}
        columns={columns}
      />
    </Card>
  )
}
